import StaticPage from "./StaticPage";

const content = {
  en: {
    title: "About FileNesto",
    subtitle: "Smart online file tools — fast, free and secure for everyone.",
    description: "Discover FileNesto: smart online file tools, our mission, and the team building fast, free and secure utilities — starting with PDF and expanding to Excel, Word and image tools.",
    lastUpdated: "February 2026",
    sections: [
      {
        h2: "Our mission",
        body: "FileNesto exists to make everyday file work effortless. We believe powerful file utilities should not be locked behind logins, paywalls, or watermarks. Whether you are a student joining lecture notes, a freelancer compressing a CV, or a small business preparing client deliverables, you should be able to handle your files in seconds — for free, on any device.\n\nWe ship a focused set of tools that solve the most common pain points around documents: merging, compressing, splitting, converting, rotating, removing pages, extracting content, and protecting sensitive files.",
      },
      {
        h2: "What we do today",
        body: "FileNesto currently offers 15 free tools — 12 PDF tools (merge, compress, split, PDF to Word, Word to PDF, PDF to Excel, PDF to JPG, rotate, delete pages, protect with password, extract text, and PDF preview) and 3 Excel tools (Excel to PDF, Excel to CSV, CSV to Excel). Every tool runs entirely online, with no installation required, on any device.",
      },
      {
        h2: "Where we are going",
        body: "FileNesto is not a PDF-only platform. It is a scalable foundation for online file and document tools. Excel tools are already live. Word document conversion, image transformation, and smart file workflows are on the roadmap — built on the same fast, free, and secure foundation you use today.",
      },
      {
        h2: "Our commitments",
        list: [
          "100% free core tools, with no signup required.",
          "No file storage — your files are processed in memory and discarded immediately.",
          "Bilingual French and English interface, with more languages on the way.",
          "Transparent privacy practices — see our Privacy Policy.",
          "Continuous improvement: new tools and quality fixes ship regularly.",
        ],
      },
      {
        h2: "Where we are based",
        body: "FileNesto is a digital brand based in Morocco, building products for users worldwide. We are proudly international in reach, and committed to building tools that work everywhere, in every language.",
      },
      {
        h2: "Get in touch",
        body: "Questions, feedback, partnerships, or feature requests? We love hearing from our users. Visit our Contact page or email us directly.",
      },
    ],
  },
  fr: {
    title: "À propos de FileNesto",
    subtitle: "Outils en ligne intelligents pour vos fichiers — rapides, gratuits et sécurisés.",
    description: "Découvrez FileNesto : 15 outils gratuits en ligne pour vos fichiers PDF et Excel. Notre mission : des utilitaires rapides, gratuits et sécurisés — sans inscription.",
    lastUpdated: "Février 2026",
    sections: [
      {
        h2: "Notre mission",
        body: "FileNesto existe pour rendre le travail quotidien sur fichiers simple et fluide. Nous pensons que des outils puissants ne devraient pas être bloqués derrière des comptes, des paywalls ou des filigranes. Que vous soyez étudiant assemblant des notes de cours, freelance compressant un CV, ou petite entreprise préparant des livrables clients, vous devriez pouvoir traiter vos fichiers en quelques secondes — gratuitement, sur n'importe quel appareil.\n\nNous proposons un ensemble d'outils qui résolvent les problèmes les plus fréquents autour des documents : fusion, compression, division, conversion, rotation, suppression de pages, extraction de contenu, et protection de fichiers sensibles.",
      },
      {
        h2: "Ce que nous proposons aujourd'hui",
        body: "FileNesto propose actuellement 15 outils gratuits — 12 outils PDF (fusionner, compresser, diviser, PDF vers Word, Word vers PDF, PDF vers Excel, PDF vers JPG, faire pivoter, supprimer des pages, protéger par mot de passe, extraire du texte, et aperçu PDF) et 3 outils Excel (Excel vers PDF, Excel vers CSV, CSV vers Excel). Tous les outils fonctionnent en ligne, sans installation, sur n'importe quel appareil.",
      },
      {
        h2: "Notre vision",
        body: "FileNesto n'est pas une plateforme PDF uniquement. C'est une base évolutive pour des outils de traitement de fichiers en ligne. Les outils Excel sont déjà disponibles. La conversion de documents Word, la transformation d'images et les workflows de fichiers intelligents sont sur notre feuille de route — construits sur la même base rapide, gratuite et sécurisée.",
      },
      {
        h2: "Nos engagements",
        list: [
          "Outils principaux 100% gratuits, sans inscription.",
          "Aucun stockage de fichiers — vos fichiers sont traités en mémoire et supprimés immédiatement.",
          "Interface bilingue français et anglais, avec d'autres langues à venir.",
          "Pratiques de confidentialité transparentes — voir notre politique.",
          "Amélioration continue : nouveaux outils et corrections de qualité régulièrement.",
        ],
      },
      {
        h2: "Où nous sommes basés",
        body: "FileNesto est une marque digitale basée au Maroc, construisant des produits pour des utilisateurs du monde entier. Nous sommes fièrement internationaux et engagés à concevoir des outils qui fonctionnent partout, dans chaque langue.",
      },
      {
        h2: "Nous contacter",
        body: "Questions, retours, partenariats ou demandes de fonctionnalités ? Nous aimons entendre nos utilisateurs. Visitez notre page Contact ou envoyez-nous un email directement.",
      },
    ],
  },
};

export default function About() {
  return <StaticPage content={content} slug="/about" testid="page-about" />;
}
